import { apiSlice } from './apiSlice';
import i18next from 'i18next';
import { authActions } from '../store/slices/auth'; 
export const loginApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: '/api/login',
        method: 'POST',
        body: { ...credentials },
        credentials: 'include', // Include cookies in the request
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          await i18next.reloadResources();
          return data;
        } catch (error) {
          console.error('Login or i18n reload failed:', error);
          throw error;
        }
      },
    }),

    logout: builder.mutation<void, void>({
      query: () => ({
        url: '/api/logout',
        method: 'POST',
        credentials: 'include',
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Clear auth state on successful logout
          dispatch(authActions.logout());
          // Broadcast logout to other tabs
          if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
            const channel = new BroadcastChannel('auth');
            channel.postMessage({ type: 'logout' });
            channel.close();
          }
        } catch (error) {
          console.error('Logout failed:', error);
        }
      },
    }),

    forgotPassword: builder.mutation({
      query: ({ email }) => ({
        url: '/api/send-otp',
        method: 'POST',
        body: { email },
      }),
    }),

    verifyOtp: builder.mutation({
      query: ({ email, otp }) => ({
        url: '/api/verify-otp',
        method: 'POST',
        body: { email, otp },
      }),
    }),

    resetPassword: builder.mutation({
      query: ({ email, newPassword }) => ({
        url: '/api/password/update',
        method: 'POST',
        body: { email, newPassword },
      }),
    }),

    resetPasswordMail: builder.mutation({
      query: ({ email }) => ({
        url: '/api/password/reset',
        method: 'POST',
        body: { email },
      }),
    }),

    confirmEmail: builder.mutation({
      query: ({ token, newPassword, customerId }) => ({
        url: '/api/password/reset-confirm',
        method: 'POST',
        body: {
          reset_token: token,
          new_password: newPassword,
          customer_id: customerId,
        },
      }),
    }),

    verifyEmail: builder.mutation({
      query: ({ email, token, customerId }) => ({
        url: '/api/verify-email',
        method: 'POST',
        body: { email, token, customer_id: customerId },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useVerifyOtpMutation,
  useResetPasswordMutation,
  useResetPasswordMailMutation,
  useConfirmEmailMutation,
  useVerifyEmailMutation,
} = loginApiSlice;
